export default __webpack_public_path__ + "static/JMC-logo-white-d9042f6117ec798d4ed827a8a4a2c171.svg";